// A parameter the keeper made up themselves ("+ Add custom parameter"),
// as opposed to a test TankSensei knows. Feedback #66 (2026-10-07): "an
// ability to edit or delete completely a manually added parameter". Only
// these can be renamed, given another unit, or deleted together with
// their readings; a built-in test keeps its name and its history (the
// score, alerts, dosing and the displays all read those keys). Pure,
// shared by the app and the server.

// Every key TankSensei itself writes or grades: the starting templates,
// the quarantine / cycle cards, the freshwater cards and what devices
// send. test/own-param.test.js pins it against those lists.
export const BUILTIN_PARAM_KEYS = new Set([
  'temp',
  'salinity',
  'alk',
  'calcium',
  'magnesium',
  'nitrate',
  'phosphate',
  'ph',
  'ammonia',
  'nitrite',
  'kh',
  'gh',
  'tds',
  'orp',
]);

// Keys only some tank types grade (DEFAULT_SCORING_CONFIG): a planted
// tank's potassium and iron are scored and alerted on, so there they are
// TankSensei's, while a reef keeper's potassium card is their own.
export const SUBTYPE_GRADED_KEYS = {
  'planted-high': ['potassium', 'iron'],
};

export function isOwnParam(key, card, subtypeSlug = null) {
  if (!card || card.custom !== true || BUILTIN_PARAM_KEYS.has(key)) return false;
  return !(SUBTYPE_GRADED_KEYS[subtypeSlug] || []).includes(key);
}

// What the delete route answers before touching anything: null when the
// delete may go ahead, else { status, error, code }. Owner only, like
// every parameter setting; readings only with a keeper's own parameter.
export function paramDeleteProblem({ role, key, card, withReadings, subtypeSlug = null }) {
  if (role !== 'owner') {
    return { status: 403, error: 'Only the tank owner can change parameter settings.' };
  }
  if (!card) return { status: 404, error: 'That parameter is not on this tank.' };
  if (withReadings && !isOwnParam(key, card, subtypeSlug)) {
    return {
      status: 400,
      error: 'Only a parameter you added yourself can be deleted with its readings.',
      code: 'not_own_param',
    };
  }
  return null;
}
